<template>
  <span v-if="name != 'admin'">
    <v-btn icon class="mx-0" @click="deletestaff()">
      <v-icon color="pink">delete</v-icon>
    </v-btn>
  </span>
</template>

<script>
import { deleteModule } from "@/model";
import moment from "moment";

export default {
  name: "DeleteStaff",
  props: {
    name: {
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    deletestaff() {
      let self = this;
      let confirmed = confirm(
        "Warning!!! \n This will delete this staff, do you continue?",
        "Exodus",
        "Yes",
        "No"
      );

      if (confirmed) {
        let datenow = moment().format("DD/MM/YYYY");
        console.log(datenow);

        deleteModule("staff", this.name, function (response) {
          if (response) {
            console.log("This is response: ", response);
            alert("Staff has been successfully deleted");
            self.$store.dispatch("updateStaffs");
          } else {
            console.log(null);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
</style>